export const jobTypeCodes = {
  JobOrder: 'JO',
  SalesOrder: 'SO',
  PriceQuote: 'PQ',
  CatalogTemporaryOrder: 'PQCTO',
  LayawayOrder: 'POS_LSO',
  OutgoingConsignment: 'OC',
}
